import { createContext } from 'react'
import type { ChangeBaseParametersContextData } from './ChangeBaseParametersContext'

export const InternalChangeBaseParametersOverlayContext = createContext<ChangeBaseParametersContextData | undefined>(undefined)
InternalChangeBaseParametersOverlayContext.displayName = 'ChangeBaseParametersOverlayContext'
